import { render, staticRenderFns } from "./CategoryMianLiaoStylePage.vue?vue&type=template&id=27531d44&scoped=true&"
import script from "./CategoryMianLiaoStylePage.vue?vue&type=script&lang=js&"
export * from "./CategoryMianLiaoStylePage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMianLiaoStylePage.vue?vue&type=style&index=0&id=27531d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27531d44",
  null
  
)

export default component.exports